import styled from 'styled-components';

const Container = styled.div`

`;

const Title = styled.h2`
  font-size: 18px;
  text-align: center;
  font-weight: normal;
`;

const MaterialTitle = ({ materialName }) => (
  <Container>
    <Title>{materialName}</Title>
  </Container>
);

export default MaterialTitle;
